import { View } from '@components';
import styled from 'styled-components';

const ExternalLink = styled(View)`
  cursor: pointer;
  color: #1890ff;

  :hover {
    text-decoration: underline;
  }
`;

export default ExternalLink;
